import React from 'react';
import { Card, Box, Typography, CardMedia } from '@mui/material';
import { Flower2, Camera, Pencil, Trash2 } from 'lucide-react';

export default function SpaMenuCard({ item, onImageClick, onEdit, onDelete, children }) {
  return (
    <Card
      sx={{
        width: 255,
        height: 360,
        minHeight: 320,
        p: 2,
        borderRadius: 3,
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        position: 'relative',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          opacity: 0,
          transition: 'opacity 0.3s ease',
          display: 'flex',
          gap: 1,
          zIndex: 2,
          '.MuiCard-root:hover &': {
            opacity: 1,
          }
        }}
      >
        <Box
          onClick={() => {
            onEdit?.();
          }}
          sx={{
            width: 24,
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex:20,
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.1)'
            }
          }}
        >
          <Pencil size={16} />
        </Box>
        <Box
          onClick={() => {
            console.log('🗑 Delete icon clicked', item);
            onDelete?.(item);
          }}
          sx={{
            width: 24,
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 10,
            transition: 'transform 0.3s ease',
            '&:hover': {
              transform: 'scale(1.1)'
            }
          }}
        >
          <Trash2 size={16} />
        </Box>
      </Box>
      <Box
        onClick={onImageClick}
        sx={{
          width: 120,
          height: 120,
          borderRadius: '50%',
          overflow: 'hidden',
          mx: 'auto',
          mb: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          cursor: 'pointer',
          position: 'relative',
          flexShrink: 0,
          '&:hover img': {
            transform: 'scale(1.1)',
            filter: 'brightness(0.8)',
          },
          '&:hover .overlay': {
            opacity: 1,
          }
        }}
      >
        {item.image ? (
          <>
            <CardMedia
              component="img"
              image={item.image}
              alt={item.name}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'transform 0.4s ease, filter 0.4s ease',
              }}
            />
            <Box
              className="overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                opacity: 0,
                transition: 'opacity 0.3s ease',
              }}
            >
              <Box sx={{ color: '#fff', opacity: 0.8 }}>
                <Camera size={26} />
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Flower2 size={28} color="#888" />
            <Box
              className="overlay"
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                opacity: 0,
                transition: 'opacity 0.3s ease',
              }}
            >
              <Box sx={{ color: '#fff', opacity: 0.8 }}>
                <Camera size={26} />
              </Box>
            </Box>
          </>
        )}
      </Box>

      {children}
    </Card>
  );
}
